(() => {
  const initializedAttr = 'minipixHomeStickyInitialized';
  const visibleClass = 'is-visible';
  const bodyVisibleClass = 'minipix-home-sticky-visible';
  const bodyPromoVisibleClass = 'minipix-home-sticky-promo-visible';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const transitionDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220;

  const findHero = (sticky) => {
    const selector = sticky.dataset.minipixHomeStickyHeroSelector;
    if (selector) {
      const hero = document.querySelector(selector);
      if (hero) return hero;
    }

    return document.querySelector('[id^="minipix-configurator-hero-"]');
  };

  const initSticky = (sticky) => {
    if (sticky.dataset[initializedAttr] === 'true') return;

    const isPromo = sticky.dataset.minipixHomeStickyPromo === 'true';
    const promoAnchor = isPromo ? document.querySelector('[data-minipix-campaign-anchor]') : null;
    const hero = findHero(sticky);
    const trigger = promoAnchor || hero;
    let hideTimer = null;
    let triggerHasPassed = false;

    if (!trigger) return;

    sticky.dataset[initializedAttr] = 'true';

    const isViewportEnabled = () => {
      const isMobile = mobileQuery.matches;
      return isMobile ? sticky.dataset.enableMobile !== 'false' : sticky.dataset.enableDesktop !== 'false';
    };

    const setVisible = (visible) => {
      const shouldShow = visible && isViewportEnabled();
      window.clearTimeout(hideTimer);

      if (shouldShow) {
        sticky.hidden = false;
        window.requestAnimationFrame(() => {
          sticky.classList.add(visibleClass);
          document.body.classList.add(bodyVisibleClass);
          if (isPromo) {
            document.body.classList.add(bodyPromoVisibleClass);
          }
        });
        return;
      }

      sticky.classList.remove(visibleClass);
      document.body.classList.remove(bodyVisibleClass);
      if (isPromo) {
        document.body.classList.remove(bodyPromoVisibleClass);
      }

      hideTimer = window.setTimeout(() => {
        if (!sticky.classList.contains(visibleClass)) {
          sticky.hidden = true;
        }
      }, transitionDuration);
    };

    const updateFromTriggerPosition = () => {
      triggerHasPassed = trigger.getBoundingClientRect().bottom <= 0;
      setVisible(triggerHasPassed);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        triggerHasPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        setVisible(triggerHasPassed);
      },
      { threshold: 0 }
    );

    observer.observe(trigger);
    updateFromTriggerPosition();

    const handleViewportChange = () => {
      setVisible(triggerHasPassed);
    };

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', handleViewportChange);
    } else {
      mobileQuery.addListener(handleViewportChange);
    }

    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(sticky)) return;

      observer.disconnect();
      if (mobileQuery.removeEventListener) {
        mobileQuery.removeEventListener('change', handleViewportChange);
      } else {
        mobileQuery.removeListener(handleViewportChange);
      }
      document.body.classList.remove(bodyVisibleClass);
      if (isPromo) {
        document.body.classList.remove(bodyPromoVisibleClass);
      }
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-minipix-home-sticky-cta]').forEach(initSticky);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
